import * as React from "react";
import './Privacy.css';


export default class PrivacyPage extends React.PureComponent {

    render() {
        return <div className='container'>
            <div className='privacy_page'>
                <h2>Privacy Policy</h2>
                <p>Olee built the Yomi app as a Free app. This SERVICE is provided by Olee at no cost and is intended
                    for
                    use as is.</p>
                <p>This page is used to inform visitors regarding our policies with the collection, use, and disclosure
                    of
                    Personal Information if anyone decided to use our Service.</p>
                <p>If you choose to use our Service, then you agree to the collection and use of information in relation
                    to
                    this policy. The Personal Information that we collect is used for providing and improving the
                    Service.
                    We will not use or share your information with anyone except as described in this Privacy
                    Policy.</p>
                <p>The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is
                    accessible at Yomi unless otherwise defined in this Privacy Policy.</p>
                <p><strong>Information Collection and Use</strong></p>
                <p>For a better experience, while using our Service, we may require you to provide us with certain
                    personally identifiable information, including but not limited to Name. The information that we
                    request
                    will be retained by us and used as described in this privacy policy.</p>
                <p>The app does use third party services that may collect information used to identify you.</p>
                <p>Link to privacy policy of third party service providers used by the app</p>
                <ul>
                    <li><a href="https://www.google.com/policies/privacy/privacy.js">Google Play Services</a></li>
                </ul>
                <p><strong>Service Providers</strong></p>
                <p>We may employ third-party companies and individuals due to the following reasons:</p>
                <ul>
                    <li>To facilitate our Service;</li>
                    <li>To provide the Service on our behalf;</li>
                    <li>To perform Service-related services; or</li>
                    <li>To assist us in analyzing how our Service is used.</li>
                </ul>
                <p>We want to inform users of this Service that these third parties have access to your Personal
                    Information. The reason is to perform the tasks assigned to them on our behalf. However, they are
                    obligated not to disclose or use the information for any other purpose.</p>
                <p><strong>Security</strong></p>
                <p>We value your trust in providing us with your Personal Information, thus we are striving to use
                    commercially acceptable means of protecting it. But remember that no method of transmission over the
                    Internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its
                    absolute security.</p>
                <p><strong>Links to Other Sites</strong></p>
                <p>This Service may contain links to other sites. If you click on a third-party link, you will be
                    directed
                    to that site. Note that these external sites are not operated by us. Therefore, we strongly advise
                    you
                    to review the Privacy Policy of these websites. We have no control over and assume no responsibility
                    for
                    the content, privacy policies, or practices of any third-party sites or services.</p>
                <p><strong>Children&rsquo;s Privacy</strong></p>
                <p>These Services do not address anyone under the age of 13. We do not knowingly collect personally
                    identifiable information from children under 13. In the case we discover that a child under 13 has
                    provided us with personal information, we immediately delete this from our servers. If you are a
                    parent
                    or guardian and you are aware that your child has provided us with personal information, please
                    contact
                    us so that we will be able to do the necessary actions.</p>
                <p><strong>Changes to This Privacy Policy</strong></p>
                <p>We may update our Privacy Policy from time to time. Thus, you are advised to review this page
                    periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on
                    this page. These changes are effective immediately after they are posted on this page.</p>
                <p><strong>Contact Us</strong></p>
                <p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us
                    at <a
                        href="mailto:soheekim@olee.co.kr">soheekim@olee.co.kr</a>.</p>
                <p>&nbsp;</p>
                <h2>&nbsp;</h2>
                <h2>&nbsp;</h2>
                <h2>Terms &amp; Conditions</h2>
                <p>By downloading or using the app, these terms will automatically apply to you &ndash; you should make
                    sure
                    therefore that you read them carefully before using the app. You&rsquo;re not allowed to copy, or
                    modify
                    the app, any part of the app, or our trademarks in any way. You&rsquo;re not allowed to attempt to
                    extract the source code of the app, and you also shouldn&rsquo;t try to translate the app into other
                    languages, or make derivative versions. The app itself, and all the trade marks, copyright, database
                    rights and other intellectual property rights related to it, still belong to Olee.</p>
                <p>Olee is committed to ensuring that the app is as useful and efficient as possible. For that reason,
                    we
                    reserve the right to make changes to the app or to charge for its services, at any time and for any
                    reason. We will never charge you for the app or its services without making it very clear to you
                    exactly
                    what you&rsquo;re paying for.</p>
                <p>The Yomi app stores and processes personal data that you have provided to us, in order to provide our
                    Service. It&rsquo;s your responsibility to keep your phone and access to the app secure. We
                    therefore
                    recommend that you do not jailbreak or root your phone, which is the process of removing software
                    restrictions and limitations imposed by the official operating system of your device. It could make
                    your
                    phone vulnerable to malware/viruses/malicious programs, compromise your phone&rsquo;s security
                    features
                    and it could mean that the Yomi app won&rsquo;t work properly or at all.</p>
                <p>You should be aware that there are certain things that Olee will not take responsibility for. Certain
                    functions of the app will require the app to have an active internet connection. The connection can
                    be
                    Wi-Fi, or provided by your mobile network provider, but Olee cannot take responsibility for the app
                    not
                    working at full functionality if you don&rsquo;t have access to Wi-Fi, and you don&rsquo;t have any
                    of
                    your data allowance left.</p>
                <p>If you&rsquo;re using the app outside of an area with Wi-Fi, you should remember that your terms of
                    the
                    agreement with your mobile network provider will still apply. As a result, you may be charged by
                    your
                    mobile provider for the cost of data for the duration of the connection while accessing the app, or
                    other third party charges. In using the app, you&rsquo;re accepting responsibility for any such
                    charges,
                    including roaming data charges if you use the app outside of your home territory (i.e. region or
                    country) without turning off data roaming. If you are not the bill payer for the device on which
                    you&rsquo;re using the app, please be aware that we assume that you have received permission from
                    the
                    bill payer for using the app.</p>
                <p>Along the same lines, Olee cannot always take responsibility for the way you use the app i.e. You
                    need to
                    make sure that your device stays charged &ndash; if it runs out of battery and you can&rsquo;t turn
                    it
                    on to avail the Service, Olee cannot accept responsibility.</p>
                <p>With respect to Olee&rsquo;s responsibility for your use of the app, when you&rsquo;re using the app,
                    it&rsquo;s important to bear in mind that although we endeavour to ensure that it is updated and
                    correct
                    at all times, we rely on third parties to provide information to us so that we can make it available
                    to
                    you. Olee accepts no liability for any loss, direct or indirect, you experience as a result of
                    relying
                    wholly on this functionality of the app.</p>
                <p>At some point, we may wish to update the app. The app is currently available on
                    Android &amp; iOS &ndash; the requirements for both systems (and for any additional systems we
                    decide to
                    extend the availability of the app to) may change, and you&rsquo;ll need to download the updates if
                    you
                    want to keep using the app. Olee does not promise that it will always update the app so that it is
                    relevant to you and/or works with the Android &amp; iOS version that you have installed on your
                    device.
                    However, you promise to always accept updates to the application when offered to you, We may also
                    wish
                    to stop providing the app, and may terminate use of it at any time without giving notice of
                    termination
                    to you. Unless we tell you otherwise, upon any termination, (a) the rights and licenses granted to
                    you
                    in these terms will end; (b) you must stop using the app, and (if needed) delete it from your
                    device.</p>
                <p><strong>Changes to This Terms and Conditions</strong></p>
                <p>We may update our Terms and Conditions from time to time. Thus, you are advised to review this page
                    periodically for any changes. We will notify you of any changes by posting the new Terms and
                    Conditions
                    on this page. These changes are effective immediately after they are posted on this page.</p>
                <p><strong>Contact Us</strong></p>
                <p>If you have any questions or suggestions about our Terms and Conditions, do not hesitate to contact
                    us
                    at <a href="mailto:soheekim@olee.co.kr">soheekim@olee.co.kr</a>.</p>
            </div>
        </div>;
    }

}
